import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { MessageService } from 'primeng/api';
import { catchError } from 'rxjs';
import { KeyService } from '../services/key.service';
import { showError } from '../shared/httpContextTokens';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const messageService = inject(MessageService);
    const keycloakService = inject(KeycloakService);
    const keyService = inject(KeyService);

    return next(req).pipe(
        catchError(async (error: HttpErrorResponse) => {
            if (error.error.data) {
                const { publicKey } = await keyService.getServerKey(req.url);
                const decodedBody = await keycloakService.decrypt(
                    { publicKey },
                    error.error.data,
                    error.headers.get('x-crypto-enabled'),
                    false
                );
                const decryptedError = JSON.parse(JSON.stringify(decodedBody));
                messageService.add({
                    key: 'errorToast',
                    severity: 'error',
                    summary: 'Error',
                    detail: decryptedError.message,
                    life: 5000
                });
                throw error;
            }

            let errorMessage = 'Something went wrong. Please try again.';
            if (error.error?.message) {
                errorMessage = error.error.message;
            } else if (error.error?.error) {
                errorMessage = error.error.error;
            } else if (typeof error.error === 'string') {
                errorMessage = error.error;
            } else if (error.message) {
                errorMessage = error.message;
            }

            const showErrorContext = req.context.get(showError);

            if (showErrorContext) {
                messageService.add({
                    key: 'errorToast',
                    severity: 'error',
                    summary: 'Error',
                    detail: errorMessage,
                    life: 5000
                });
            }
            throw error;
        })
    );
};
